import type { JSX } from 'react';

import { Card } from '@change-corgi/design-system-legacy/components/content';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { useDashboardReskinExperiment } from '../../../../hooks/useDashboardReskinExperiment';

import { PromotionHistory } from './components/PromotionHistory';
import { RecentPromotionsList } from './components/RecentPromotionsList';
import { TopSignatureSources } from './components/TopSignatureSources';
import { usePetitionInsights } from './hooks/usePetitionInsights';
import { PetitionInsights as PetitionInsightsReskin } from './index_new';

export function PetitionInsights(): JSX.Element | null {
	const { data } = usePetitionInsights();

	const {
		data: { isEnabled: isReskinEnabled },
	} = useDashboardReskinExperiment();

	if (!data.shouldShowPetitionInsights) return null;

	if (isReskinEnabled) {
		return <PetitionInsightsReskin />;
	}

	return (
		<Box as="section" aria-labelledby="petition-insights-title" role="group" data-qa="promotion-insights">
			{data.shouldShowSignatureSources && (
				<Card mt="16px" backgroundColor="white" sx={{ border: 'unset', borderRadius: 'big' }}>
					<TopSignatureSources />
				</Card>
			)}
			{data.shouldShowPromotionStats && (
				<Card mt="16px" backgroundColor="white" sx={{ border: 'unset', borderRadius: 'big' }}>
					<PromotionHistory />
					<RecentPromotionsList />
				</Card>
			)}
		</Box>
	);
}
